import HeroFamily from '@images/custom/images/topBanner/topBanner.png'
import { FONT_FAMILY } from 'styles/typography'
import { hexToRgba } from 'styles/theme.js'

const themeStyles = colors => {
  const defaultStyles = {
    container: {
      position: 'relative',
      fontFamily: FONT_FAMILY,
      height: '300px',
      overflow: 'hidden',
      zIndex: 1
    },
    mobileContainer: {
      position: 'relative',
      fontFamily: FONT_FAMILY,
      height: 175,
      overflow: 'hidden',
      zIndex: 1
    },
    mobileBanner: {
      position: 'absolute',
      transform: 'scale(0.6)',
      zIndex: 1,
      margin: 0,
      padding: 0,
      top: -75,
      left: -60
    },
    backgroundImg: {
      width: '100%',
      position: 'absolute',
      transform: 'translateY(-30%)',
      minHeight: 220
    },
    mobileBackgroundImg: {
      width: '100%',
      position: 'absolute',
      transform: 'translateY(-30%)',
      minHeight: 'auto'
    },
    textContainer: {
      display: 'flex',
      color: colors.approxBlack,
      flexDirection: 'column',
      justifyContent: 'flex-start',
      padding: '50px 0 50px 0px',
      width: '60%',
    },
    heading: {
      fontSize: 30,
      fontWeight: 700,
      lineHeight: '34px',
      marginBottom: 19,
      zIndex: 3
    },
    text: {
      margin: 0,
      fontSize: 18,
      fontWeight: 400,
      lineHeight: '23px',
      zIndex: 3
    },
    image: {
      width: '50%',
      height: '100%',
      backgroundImage: `url(${HeroFamily})`,
      backgroundSize: 'cover',
      backgroundPosition: 'right'
    },
    relative: {
      position: 'relative',
      marginBottom: 0,
      padding: 0,
      border: 0
    },
    exploreService: {
      zIndex: 3,
      width: 'fit-content',
      padding: '0 20px',
      height: 35,
      borderRadius: 18,
      lineHeight: '35px',
      marginTop: 20,
      fontWeight: 700,
      background: colors.primary,
      color: colors.white,
      textAlign: 'center',
      cursor: 'pointer'
    },
    accountInfoContainer: {
      fontFamily: FONT_FAMILY,
      display: 'flex',
      height: '300px',
      position: 'absolute',
      top: '0px',
      right: '0px',
      flexDirection: 'row',
      justifyContent: 'space-around',
      alignItems: 'center',
      color: colors.black
    },
    mobileAccountInfoContainer: {
      fontFamily: FONT_FAMILY,
      display: 'flex',
      flexBasis: 'content',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
      background: colors.white,
      marginBottom: 0
    },
    accountInfo: {
      display: 'flex',
      flexDirection: 'column',
      padding: 35,
      maxWidth: 369,
      minHeight: 175,
      borderRadius: 10,
      justifyContent: 'space-evenly',
      backgroundColor: hexToRgba(colors.white, 0.8)
    },
    mobileAccountInfo: {
      display: 'flex',
      flexDirection: 'column',
      padding: '35px 0',
      width: '100%',
      color: colors.black,
      borderRadius: 10,
      backgroundColor: hexToRgba(colors.white, 0.8)
    },
    accountInfoTitle: {
      fontSize: 22,
      fontWeight: 700
    },
    accountInfoText: {
      fontSize: 16,
      fontWeight: 400,
      marginTop: 15
    },
    patientSwitch: {
      height: 35,
      borderRadius: 18,
      lineHeight: '35px',
      marginTop: 20,
      fontWeight: 700,
      background: colors.primary,
      color: colors.white,
      textAlign: 'center',
      cursor: 'pointer'
    },
    mobilePatientSwitch: {
      height: 35,
      borderRadius: 18,
      lineHeight: '35px',
      marginTop: 20,
      fontWeight: 700,
      background: colors.primary,
      color: colors.white,
      textAlign: 'center',
      width: 175
    },
    patientSwitchButtonInMobile: {
      marginLeft: 0,
      width: 'fit-content'
    }
  }
  return defaultStyles
}

export default themeStyles
